import React, { useContext } from 'react'
import { hasAccessToAdmin } from '../../../utils/user/permissions'
import { UserContext } from '../../wrappers/UserContext'
import LogoutButton from '../user/LogoutButton'
import ManageUsersButton from '../user/ManageUsersButton'
import AdminLink from './AdminLink'

const LandingPageNav = () => {
    const { roles } = useContext(UserContext)
    return (
        <div className="navbar landingNav">
            <div className="navbar-end">
                {/* {hasAccessToAdmin(roles) ? (
                    <div className="navbar-item">
                        <AdminLink />
                    </div>
                ) : null} */}
                {hasAccessToAdmin(roles) ? (
                    <div className="navbar-item">
                        <ManageUsersButton />
                    </div>
                ) : null}
                <div className="navbar-item">
                    <LogoutButton />
                </div>
            </div>
        </div>
    )
}

export default LandingPageNav
